import React from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import PropTypes from "prop-types";

import { FRONTEND_ROOT } from "config/constants";
import { MicrodataContext } from "config/contexts";

import styles from "./TagLink.css";

export default function TagLink({ tag }) {
  // some old RM stories don't have primary tags
  if (tag) {
    const tagUrl = tag.url.replace(FRONTEND_ROOT, "");
    return (
      <MicrodataContext.Consumer>
        {(microdata) => {
          const tagName = microdata ? <span itemProp="keywords">{tag.name}</span> : tag.name;

          return (
            <Link to={tagUrl} className={classNames(styles.root, "gtm-primary-tag-link")}>
              {tagName}
            </Link>
          );
        }}
      </MicrodataContext.Consumer>
    );
  }
  return null;
}

TagLink.propTypes = {
  tag: PropTypes.shape({
    url: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
};
